import { render, staticRenderFns } from "./CompaniesEmpty.vue?vue&type=template&id=6685004c&scoped=true&"
import script from "./CompaniesEmpty.vue?vue&type=script&lang=ts&"
export * from "./CompaniesEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6685004c",
  null
  
)

export default component.exports